// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2UjBu","label":"Radio_label__1RIjR","checkMark":"Radio_checkMark__2nEQo","disabled":"Radio_disabled__2h-6p"};